import _ from 'underscore';
import classNames from 'classnames';
import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';

import { keyCode } from '@bingads-webui/keycode';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AddFilterButton } from '@bingads-webui/filter-commons';

import { ViewAllFiltersButton } from './view-all-filters-button';
import { getAssetLibraryFilterBarReadonlyStyle } from './style';

const ReadonlyFilterBar = ({
  filters,
  onRenderFilter,
  onClickFilter,
  onClickAddFilterButton,
  i18n,
  classes,
}) => {
  const onKeyPress = (event, filter, index) => {
    if (event.which === keyCode.Enter || event.which === keyCode.Space) {
      onClickFilter(filter, index);
    }
  };

  const filterListRef = useRef();
  const onFilterBlur = () => {
    // reset scroll position to 0
    if (filterListRef.current) {
      filterListRef.current.scrollTo(0, 0);
    }
  };

  return (
    <div className={classNames(classes.filterBarReadonlyContainer)}>
      <div className="filter-list" ref={filterListRef} onBlur={onFilterBlur}>
        {filters.map((filter, index) => (
          <Fragment key={`filter-${filter.id}`}>
            <span
              onClick={() => onClickFilter(filter, index)}
              tabIndex="0"
              role="button"
              onKeyDown={event => onKeyPress(event, filter, index)}
            >
              {onRenderFilter({
                filter,
                index,
                isLast: index === filters.length - 1,
                isFirst: index === 0,
              })}
            </span>
          </Fragment>
        ))}
      </div>
      <ViewAllFiltersButton filters={filters} onClickFilter={onClickFilter} i18n={i18n} />
      <AddFilterButton i18n={i18n} onClick={onClickAddFilterButton} />
    </div>
  );
};

ReadonlyFilterBar.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({})),
  onRenderFilter: PropTypes.func.isRequired,
  onClickFilter: PropTypes.func,
  onClickAddFilterButton: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    filterBarReadonlyContainer: PropTypes.string,
  }).isRequired,
};

ReadonlyFilterBar.defaultProps = {
  filters: [],
  onClickFilter: _.noop,
  onClickAddFilterButton: _.noop,
};

export const AssetLibraryReadonlyFilterBar
  = React.memo(withDefaultStyles(ReadonlyFilterBar, getAssetLibraryFilterBarReadonlyStyle));
